// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RightCircleTwoToneSvg from "@fishx/icons-svg/es/asn/RightCircleTwoTone";
import FishxIcon from '../components/FishxIcon';

var RightCircleTwoTone = function RightCircleTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RightCircleTwoToneSvg
  }));
};

RightCircleTwoTone.displayName = 'RightCircleTwoTone';
export default React.forwardRef(RightCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RightCircleTwoTone.js
// module id = 4013
// module chunks = 0